import { registerBottomSheets, BottomSheetComponent } from '@bonanza-social/navigation';

import DailyGiftBottomSheet from './DailyGiftBottomSheet';
import DailyGiftLockedBottomSheet from './DailyGiftLockedBottomSheet';

const bottomSheets = {
  default: DailyGiftBottomSheet,
  DailyGiftLocked: DailyGiftLockedBottomSheet,
};

registerBottomSheets('dailyGift', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    dailyGift: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}
